import React from 'react';
import { Link } from 'react-router'; // For navigation links (optional)
import styled from 'styled-components';
import CallToAction from './Shared/CallToAction';
import { ScrollTo } from './Shared/ViewControl';
import { base } from './Config/app';
import {Ts, LangSwitcher} from './Config/Lang/switcher';


const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background-color: #f5f5f5; /* Light gray background */
`;

const Logo = styled.img`
  height: 50px; /* Adjust logo height */
`;

const NavLinks = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  height: 2rem;
  vertical-align: middle;

`;

const NavLink = styled.li`
  margin-right: 1rem;
  padding: 0 1rem;

  &:hover {
    /*background-color: #ccc; */
    border: 1px solid #aaa;
    border-radius: 5px;
  }
`;

const NavIcon = styled.li`
  margin-right: 1rem;

  &:hover {
    transform: scale(1.5);
  }
`;


const Header = ({lang, account, onLang}) => {
  
  const T = (value, key='home') => Ts(lang, key, value)

  return (
    <HeaderContainer>
      <Link to="/">
        <Logo src={base.logo} alt={base.title} />
      </Link>

      <LangSwitcher lang={lang} onLang={onLang} />

      <NavLinks>
        <ScrollTo to="about" label={T('about')} />
        <ScrollTo to="articles" label={T('article')} />
        <ScrollTo to="contact" label={T('contact')} />

        <NavIcon>
          <Link to="https://www.linkedin.com/showcase/clubdigital-ma" target="_blank" rel="noopener noreferrer">
            <img src="https://tech2us.ma/images/linkedin.png" alt="linkedin" title="linkedin" />
            </Link>
        </NavIcon>
        <NavIcon>
          <Link to="https://www.facebook.com/people/ClubDigitalma/61557742675040" target="_blank" rel="noopener noreferrer">
            <img src="https://tech2us.ma/images/facebook.png" alt="facebook" title="facebook" />
            </Link>
        </NavIcon>
      </NavLinks>

      <CallToAction />

    </HeaderContainer>
  );
};

export default Header;
